import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBronzeMedalIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("rect", {
		width: 32,
		height: 32,
		rx: 16,
		fill: "#896F0A",
		fillOpacity: .2
	}), /* @__PURE__ */ _jsx("path", {
		d: "M22.527 7.01045L19.1567 13.7297M13.2312 13.6679L9.46875 7.01188M13.3264 7.01188L16.2308 12.2377V12.2474L16.6443 12.9898M18.8638 7L16.234 12.2404M15.0525 20.971C15.3074 21.2269 15.6606 21.3845 16.0498 21.3845C16.8273 21.3845 17.4588 20.754 17.4588 19.9766C17.4588 19.1982 16.8273 18.5677 16.0498 18.5677L17.4626 16.8164H15.004M10.0655 18.9764C10.0655 22.3029 12.7664 25 16.089 25C19.4117 25 22.1128 22.3029 22.1128 18.9764C22.1128 15.6498 19.4117 12.9537 16.089 12.9537C12.7664 12.9537 10.0655 15.6498 10.0655 18.9764Z",
		stroke: "#896F0A",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
export default SvgBronzeMedalIcon;
